import { GripHorizontal, Image, LucideMousePointerClick, MessageSquareText } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DescriptionBox from "./DescriptionBox";
import ImageBox from "./ImageBox";
import CategorySelector from "./CategorySelector";
import TagsSelector from "./TagsSelector";
import BlogStatusBox from "./BlogStatusBox";
import { useNavigate, useParams } from "react-router-dom";
import { image } from "framer-motion/client";
import { toast } from "react-toastify";
import EditDescriptionBox from "./EditDescriptionBox";
import BlogStatusBox2Edit from "./BlogStatusBox2Edit";
import slugify from "./slugify";
import BlogDescriptionView from "./BlogDescriptionView";
import { decryptToken } from "../utils/getToken";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import OmsSpinnerData from "../Loader/Spinner";
const toYouTubeEmbed = (url) => {
    if (!url) return null;

    if (url.includes("youtu.be/")) {
        return `https://www.youtube.com/embed/${url.split("youtu.be/")[1].split("?")[0]}`;
    }

    if (url.includes("watch?v=")) {
        return `https://www.youtube.com/embed/${url.split("watch?v=")[1].split("&")[0]}`;
    }

    return null;
};



const parseDescription = (content) => {
    try {
        if (!content) return null;

        let parsed = content;

        // content is a JSON string from DB
        if (typeof parsed === "string") {
            parsed = JSON.parse(parsed);
        }

        // parsed at this point should be:  { blocks:[], entityMap:{} }
        if (parsed.blocks && parsed.entityMap) {
            return parsed;
        }

        return null;
    } catch (err) {
        console.error("parseDescription error:", err);
        return null;
    }
};



const EditBlog = () => {
    const [title, setTitle] = useState("");
    const [sections, setSections] = useState([
        { id: 1, type: "description", content: "" },
    ]);
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [activeSectionId, setActiveSectionId] = useState(null);
    const textareaRefs = useRef({});
    const sectionRefs = useRef({});
    const [allCategories, setAllCategory] = useState([])
    const [allTags, setAllTags] = useState([])
    const url = process.env.REACT_APP_LINK
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);
    const [featureImage, setFeatureImage] = useState(null);
    const { id } = useParams()
    const [author, setAuthor] = useState([])
    const [selectedAuthor, setSelectedAuthor] = useState()
    const [isEdit, setIsEdit] = useState(true)
    const [status, setStatus] = useState("Draft");
    const [blogVisibility, setBlogVisibility] = useState("Public");
    const [password, setPassword] = useState("");
    const [slug, setSlug] = useState("")
    const token = decryptToken("accessToken") || "";
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [website, setWebsite] = useState(null)
    const [load, setLoad] = useState(false);

    const navigate = useNavigate()

    const onDragEnd = async (result) => {
        if (!result.destination) return;

        const reorderedSections = Array.from(sections);
        const [movedSection] = reorderedSections.splice(result.source.index, 1);
        reorderedSections.splice(result.destination.index, 0, movedSection);
        setSections(reorderedSections);

        // Optionally update backend order immediately
        try {
            const payload = reorderedSections.map((s, index) => ({ id: s.id, order: index }));
            await fetch(`${url}/api/blog/${id}/sections/reorder`, {
                method: "PUT",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
                body: JSON.stringify({ sections: payload }),
            });
        } catch (err) {
            console.error("Error updating section order:", err);
        }
    };


    const fetchCategoriesData = async () => {
        try {
            const response = await fetch(`${url}/blog-category`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            setAllCategory(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchAuthorData = async () => {
        try {
            const response = await fetch(`${url}/blog-author`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            setAuthor(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    // const fetchSingleData = async () => {
    //     try {
    //         const response = await fetch(`${url}/api/blog/single/${id}`);
    //         const res = await response.json();
    //         if (res.success && res.data) {
    //             const blog = res.data;

    //             // 1️⃣ Title
    //             setTitle(blog.title || "");

    //             // 2️⃣ Sections
    //             setSections(
    //                 blog.sections
    //                     ? [...blog.sections].sort((a, b) => a.order - b.order)
    //                     : []
    //             );

    //             // 3️⃣ Feature Image

    //             setFeatureImage(blog.feature_image ? { image: blog.feature_image } : null);



    //             // 4️⃣ Categories
    //             if (blog.categories && blog.categories.length > 0) {
    //                 const selectedCats = blog.categories.map((c) => ({
    //                     id: c.categoryDetails.id,
    //                     name: c.categoryDetails.name,
    //                     parent: c.categoryDetails.parentDetails
    //                         ? { id: c.categoryDetails.parentDetails.id, name: c.categoryDetails.parentDetails.name }
    //                         : null,
    //                 }));
    //                 console.log(selectedCats)
    //                 setSelectedCategory(selectedCats); // pass array to your CategorySelector
    //             }


    //             // 5️⃣ Tags
    //             if (blog.tags && blog.tags.length > 0) {
    //                 const tags = blog.tags.map((t) => ({
    //                     id: t.tagDetails.id,
    //                     name: t.tagDetails.name,
    //                 }));
    //                 setSelectedTags(tags); // pass array to TagsSelector
    //             }


    //             // 6️⃣ Status
    //             setStatus(blog.status || "draft");
    //             setSelectedAuthor(blog.author_name)
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // };


    const fetchSingleData = async () => {
        setLoad(true)
        try {
            const response = await fetch(`${url}/blog/single/${id}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            if (res.success && res.data) {
                const blog = res.data;

                // 1️⃣ Title
                setTitle(blog.title || "");
                setSlug(blog.slug)
                // 2️⃣ Sections
                setSections(
                    blog.sections
                        ? blog.sections
                            .sort((a, b) => a.order - b.order)
                            .map((sec) => {
                                if (sec.type === "description") {
                                    return {
                                        ...sec,
                                        content: parseDescription(sec.content),
                                    };
                                }
                                // image / button
                                return {
                                    ...sec,
                                    content:
                                        typeof sec.content === "string"
                                            ? JSON.parse(sec.content)
                                            : sec.content,
                                };
                            })
                        : []
                );


                // 3️⃣ Feature Image
                setFeatureImage(blog.feature_image ? { image: blog.feature_image } : null);

                // 4️⃣ Categories
                if (blog.categories?.length) {
                    const selectedCats = blog.categories.map((c) => ({
                        id: c.categoryDetails.id,
                        name: c.categoryDetails.name,
                        parent: c.categoryDetails.parentDetails
                            ? {
                                id: c.categoryDetails.parentDetails.id,
                                name: c.categoryDetails.parentDetails.name,
                            }
                            : null,
                    }));
                    setSelectedCategory(selectedCats);
                }

                // 5️⃣ Tags
                if (blog.tags?.length) {
                    const tags = blog.tags.map((t) => ({
                        id: t.tagDetails.id,
                        name: t.tagDetails.name,
                    }));
                    setSelectedTags(tags);
                }

                // 6️⃣ Status
                setStatus(blog.status || "Draft");

                // 7️⃣ Visibility + Password
                setBlogVisibility(blog.visibility || "Public");
                setPassword(blog.password || "");

                // 8️⃣ Author
                setSelectedAuthor(blog.author_name ? { title: blog.author_name } : null);
                setLoad(false);
            }
        } catch (error) {
            setLoad(false)
            console.error(error);
        }
    };


    const fetchTagData = async () => {
        try {
            const response = await fetch(`${url}/tag`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();
            setAllTags(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    const addSection = (type, content = {}) => {
        const newSection = {
            id: Date.now(),
            type,
            content: type === "description"
                ? { raw: null, text: "" }
                : content,
            showTooltip: type === "image" ? false : undefined,
        };

        let updatedSections = [...sections];
        let scrollToSection = false;

        // Check if active section is the 2nd section (index 1) and adding description
        if (type === "description" && activeSectionId === sections[1]?.id && sections.length >= 2) {
            // Add description as the 3rd section (index 2)
            updatedSections.splice(2, 0, newSection);

            // Move existing image section (if any) at index 2 to index 3
            const imageSectionIndex = updatedSections.findIndex(
                (s, i) => i === 2 && s.type === "image"
            );
            if (imageSectionIndex !== -1) {
                const [imageSection] = updatedSections.splice(imageSectionIndex, 1);
                updatedSections.splice(3, 0, imageSection);
            }
            scrollToSection = true;
        } else {
            // Default: Add section at the end
            updatedSections.push(newSection);
            scrollToSection = true; // Scroll to new section for all types
        }

        setSections(updatedSections);

        // Scroll to the newly added section for all types
        if (scrollToSection) {
            setTimeout(() => {
                const sectionElement = sectionRefs.current[newSection.id];
                if (sectionElement) {
                    sectionElement.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }, 100); // Small delay to ensure DOM updates
        }
    };

    const duplicateSection = (id) => {
        const section = sections.find((s) => s.id === id);
        if (section) {
            const newSection = { ...section, id: Date.now() };
            setSections([...sections, newSection]);

            // Scroll to duplicated section for all types
            setTimeout(() => {
                const sectionElement = sectionRefs.current[newSection.id];
                if (sectionElement) {
                    sectionElement.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }, 100);
        }
    };

    const deleteSection = (id) => {
        if (sections.length === 1 && sections[0].type === "description") {
            alert("At least one description section is required.");
            return;
        }
        setSections(sections.filter((s) => s.id !== id));
        if (activeSectionId === id) {
            setActiveSectionId(null);
        }
    };

    const handleImageSelect = (imageObj, sectionId = null) => {
        if (sectionId) {
            setSections(
                sections.map((s) =>
                    s.id === sectionId
                        ? { ...s, content: { ...s.content, url: imageObj.url, title: s.content.title || "" } }
                        : s
                )
            );
        } else {
            addSection("image", { url: imageObj.url, title: "" });
        }
        setIsImageModalOpen(false);
    };

    const handleDescriptionFocus = (sectionId) => {
        setActiveSectionId(sectionId);
    };

    const handleDescriptionBlur = () => {
        setActiveSectionId(null);
    };


    const handleSubmit = async ({ status, visibility, password, action }) => {
        if (!title.trim()) {
            alert("Please enter a title.");
            return;
        }

        const normalizedStatus = status.toLowerCase();
        const stringifyContent = (section) => {
            if (section.type === "description") {
                return JSON.stringify(section.content); // 🔥 convert RAW object to JSON string
            }
            return section.content; // images/buttons remain object
        };


        // const payload = {
        //     title,
        //     sections,
        //     category_id: selectedCategory ? selectedCategory.id : null,
        //     tags: selectedTags,
        //     // feature_image: featureImage,
        //     status,
        // };

        // const payload = {
        //     title,
        //     feature_image: featureImage?.image, // from your upload or URL
        //     sections: sections.map((section, index) => ({
        //         ...section,
        //         order: index,
        //     })),
        //     categories: selectedCategory,    // from your CategorySelector (array of objects)
        //     tags: selectedTags,          // optional
        //     status: status,
        //     author_name: selectedAuthor?.title || selectedAuthor,
        // };

        // const payload = {
        //     title,
        //     feature_image: featureImage?.image,
        //     sections: sections.map((section, index) => ({
        //         ...section,
        //         order: index,
        //     })),
        //     categories: selectedCategory,
        //     tags: selectedTags,
        //     status,
        //     visibility: blogVisibility,
        //     password: blogVisibility === "Password" ? password : null,
        //     author_name: selectedAuthor?.title || selectedAuthor,
        // };

        // const payload = {
        //     title,
        //     feature_image: featureImage?.image,
        //     sections: sections.map((section, index) => ({
        //         ...section,
        //         order: index,
        //     })),
        //     categories: selectedCategory,
        //     tags: selectedTags,

        //     status: status,
        //     visibility: visibility,
        //     password: visibility === "Password" ? password : null,

        //     author_name: selectedAuthor?.title || selectedAuthor,
        // };


        const payload = {
            title,
            slug,
            feature_image: featureImage?.image,

            sections: sections.map((section, index) => ({
                id: section.id,
                type: section.type,
                content: stringifyContent(section),  // 🔥 FIX
                order: index,
            })),

            categories: selectedCategory,
            tags: selectedTags,
            status: normalizedStatus,
            visibility,
            password: visibility === "Password" ? password : null,
            author_name: selectedAuthor?.title || selectedAuthor,
        };




        try {
            const res = await fetch(`${url}/blog/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (res.ok) {
                if (action === "preview") {
                    window.open(`/admin/preview-blog/${data.data.slug}/${data.data.id || "temp"}`, "_blank");
                    window.location.href = (`/edit-blog/${data.data.id}`)

                } else {
                    navigate("/blog")
                    toast.success("✅ Blog saved successfully!", {
                        position: "top-center",
                        autoClose: 2000
                    });
                }
            } else {
                alert("❌ Failed to save blog: " + data.message);
            }
        } catch (err) {
            console.error(err);
            alert("Error saving blog. Check console for details.");
        }
    };

    const fetchSingleuser = async () => {
        try {
            const response = await fetch(`${url}/register/single/${isLoggedIn.main_id}`, {
                method: "GET",

                headers: {
                    Authorization: `Bearer ${token}`,
                },

            });
            const res = await response.json();
            setWebsite(res?.users?.website_link || "")
            // setUserData(res.users);
            // setFormData(res.users);
            // setOriginalFormData(res.users);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchCategoriesData();
        fetchTagData();
        fetchSingleData();
        fetchAuthorData();
        fetchSingleuser();
    }, [])

    if (load) {
        return (
            <OmsSpinnerData />
        );
    }

    return (
        <div className="p-2 flex flex-col lg:flex-row items-start gap-4">
            <div className="w-full lg:flex-[2]">
                <div className="p-4 bg-white shadow-md rounded-lg">
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Enter blog title"
                        className="w-full border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 transition text-xl"
                    />
                    <div className="mt-3">
                        {/* <label className="text-sm font-semibold text-gray-700">
                            Blog Slug
                        </label> */}

                        <input
                            type="text"
                            value={slug}
                            onChange={(e) => setSlug(e.target.value)}
                            className="w-full mt-1 border border-gray-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500 outline-none"
                            placeholder="edit-blog-slug-here"
                        />

                        {
                            website ? <p
                                className="text-sm text-gray-800 mt-2 cursor-pointer break-all"
                                onClick={() =>
                                    window.open(
                                        `${website}/blogs/${slugify(slug)}/${id}`,
                                        "_blank"
                                    )
                                }
                            >
                                🔗 {website}/blogs/{slug}/{id}
                            </p> : null
                        }

                    </div>

                </div>

                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="sections">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {sections.map((section, index) => (
                                    <Draggable key={section.id} draggableId={String(section.id)} index={index}>
                                        {(provided) => (
                                            <div
                                                ref={(el) => {
                                                    provided.innerRef(el);
                                                    sectionRefs.current[section.id] = el;
                                                }}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                className="p-4 bg-white mt-4 shadow-md rounded-lg"
                                            >
                                                <div className="text-gray-300 flex justify-center items-center opacity-80">
                                                    <GripHorizontal />
                                                </div>
                                                {section.type === "description" && (
                                                    <div>
                                                        <EditDescriptionBox
                                                            content={section.content.raw || section.content}     // raw DraftJS JSON

                                                            onChange={(raw) => {
                                                                setSections(sections.map(s =>
                                                                    s.id === section.id
                                                                        ? { ...s, content: raw }
                                                                        : s
                                                                ));
                                                            }}
                                                            textareaRef={(el) => (textareaRefs.current[section.id] = el)}
                                                            onFocus={() => handleDescriptionFocus(section.id)}
                                                            onBlur={handleDescriptionBlur}
                                                        />
                                                        <BlogDescriptionView
                                                            key={section.id}
                                                            raw={section.content}
                                                        />

                                                        <div className="flex justify-start gap-1 items-center text-gray-700 font-medium">
                                                            <button
                                                                onClick={() => duplicateSection(section.id)}
                                                                className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                            >
                                                                <span className="text-indigo-500 font-semibold text-sm hover:underline">
                                                                    Duplicate
                                                                </span>
                                                            </button>
                                                            <div className="w-0.5 h-4 bg-gradient-to-b from-gray-400 via-gray-300 to-gray-400 rounded-full"></div>
                                                            <button
                                                                onClick={() => deleteSection(section.id)}
                                                                className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                            >
                                                                <span className="text-red-500 font-semibold text-sm hover:underline">Delete</span>
                                                            </button>
                                                        </div>

                                                    </div>
                                                )}
                                                {section.type === "image" && (() => {
                                                    const rawContent =
                                                        typeof section.content === "string"
                                                            ? JSON.parse(section.content)
                                                            : section.content || {};

                                                    const contentObj = {
                                                        title: rawContent.title || "",
                                                        images: rawContent.images || (
                                                            rawContent.image || rawContent.url
                                                                ? [{ image: rawContent.image || rawContent.url }]
                                                                : []
                                                        ),
                                                    };


                                                    return (
                                                        <div>
                                                            <input
                                                                type="text"
                                                                value={contentObj.title}
                                                                onChange={(e) => {
                                                                    const updated = { ...rawContent, title: e.target.value };
                                                                    setSections(
                                                                        sections.map((s) =>
                                                                            s.id === section.id ? { ...s, content: updated } : s
                                                                        )
                                                                    );
                                                                }}
                                                                placeholder="Enter image title"
                                                                className="w-full border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 transition text-sm sm:text-base"
                                                            />

                                                            <div className="my-3 flex justify-center items-center">
                                                                <ImageBox
                                                                    mode="multiple"
                                                                    selectedImages={contentObj.images}
                                                                    onSelect={(imagesArray) => {
                                                                        setSections(
                                                                            sections.map((s) =>
                                                                                s.id === section.id
                                                                                    ? {
                                                                                        ...s,
                                                                                        content: {
                                                                                            ...rawContent,
                                                                                            images: imagesArray
                                                                                        }
                                                                                    }
                                                                                    : s
                                                                            )
                                                                        );
                                                                    }}

                                                                />


                                                            </div>

                                                            <div className="flex justify-start gap-1 items-center text-gray-700 font-medium">
                                                                <button
                                                                    onClick={() => duplicateSection(section.id)}
                                                                    className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                                >
                                                                    <span className="text-indigo-500 font-semibold text-sm hover:underline">
                                                                        Duplicate
                                                                    </span>
                                                                </button>
                                                                <div className="w-0.5 h-4 bg-gradient-to-b from-gray-400 via-gray-300 to-gray-400 rounded-full"></div>
                                                                <button
                                                                    onClick={() => deleteSection(section.id)}
                                                                    className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                                >
                                                                    <span className="text-red-500 font-semibold text-sm hover:underline">
                                                                        Delete
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    );
                                                })()}



                                                {section.type === "button" && (
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                        <input
                                                            type="text"
                                                            value={section.content.text}
                                                            onChange={(e) => {
                                                                setSections(
                                                                    sections.map((s) =>
                                                                        s.id === section.id ? { ...s, content: { ...s.content, text: e.target.value } } : s
                                                                    )
                                                                );
                                                            }}
                                                            placeholder="Enter button text"
                                                            className="w-full border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 transition text-sm sm:text-base"
                                                        />
                                                        <input
                                                            type="text"
                                                            value={section.content.action}
                                                            onChange={(e) => {
                                                                setSections(
                                                                    sections.map((s) =>
                                                                        s.id === section.id ? { ...s, content: { ...s.content, action: e.target.value } } : s
                                                                    )
                                                                );
                                                            }}
                                                            placeholder="Enter button action (e.g., URL or function)"
                                                            className="w-full border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 transition text-sm sm:text-base"
                                                        />
                                                        <div className="flex justify-start gap-1 items-center text-gray-700 font-medium">
                                                            <button
                                                                onClick={() => duplicateSection(section.id)}
                                                                className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                            >
                                                                <span className="text-indigo-500 font-semibold text-sm hover:underline">
                                                                    Duplicate
                                                                </span>
                                                            </button>
                                                            <div className="w-0.5 h-4 bg-gradient-to-b from-gray-400 via-gray-300 to-gray-400 rounded-full"></div>
                                                            <button
                                                                onClick={() => deleteSection(section.id)}
                                                                className="flex items-center gap-1 px-2 py-1 rounded cursor-pointer transition"
                                                            >
                                                                <span className="text-red-500 font-semibold text-sm hover:underline">Delete</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>


                {isImageModalOpen && (
                    <ImageBox

                        selectedImage={null}
                        onSelect={handleImageSelect}
                        onDelete={() => setIsImageModalOpen(false)}
                        onClose={() => setIsImageModalOpen(false)}
                    />
                )}
                <div className="flex justify-center mt-4">
                    <AddTool
                        addSection={addSection}
                        openImageModal={() => setIsImageModalOpen(true)}
                    />
                </div>
            </div>
            <div className="w-full lg:max-w-xs flex flex-col gap-4">
                <div className="p-4 bg-white shadow-md rounded-lg flex flex-col justify-center order-6 lg:order-1">
                    {/* <BlogStatusBox onChange={setStatus} handleSubmit={handleSubmit} editing={isEdit} /> */}
                    <BlogStatusBox2Edit
                        blogId={id}
                        status={status}
                        setStatus={setStatus}
                        visibility={blogVisibility}
                        setVisibility={setBlogVisibility}
                        password={password}
                        setPassword={setPassword}
                        onSuccess={handleSubmit}
                        isEdit={true}
                        slug={slug}
                    />


                </div>
                <div className="p-4 bg-white shadow-md rounded-lg flex flex-col justify-center order-2 lg:order-2">
                    <div>
                        <AuthorSelect
                            authors={author}
                            onSelect={(a) => setSelectedAuthor(a)}
                            fetchAuthors={fetchAuthorData}
                            value={selectedAuthor}
                        />
                    </div>
                </div>
                <div className="p-4 bg-white shadow-md rounded-lg flex flex-col justify-center order-3 lg:order-3">
                    <h3 className="text-[16px] font-semibold text-black/80">Feature Image</h3>
                    <span className="pt-2">
                        {console.log(featureImage)}
                        <ImageBox
                            mode="single"
                            selectedImage={
                                featureImage?.image
                                    ? { image: featureImage.image }
                                    : { image: "" }  // FORCE single-image mode
                            }

                            onSelect={(imgObj) => {
                                const imageUrl = imgObj.image || imgObj.url;
                                setFeatureImage({ image: imageUrl });
                            }}

                            onDelete={() => setFeatureImage(null)}
                        />

                    </span>
                </div>

                <div className="p-4 bg-white shadow-md rounded-lg flex flex-col order-4 lg:order-4">
                    <CategorySelector categories={allCategories} onSelect={setSelectedCategory} selected={selectedCategory} />
                </div>
                <div className="p-4 bg-white shadow-md rounded-lg flex flex-col order-5 lg:order-5">
                    <TagsSelector tags={allTags} onChange={setSelectedTags} selected={selectedTags} />
                </div>
            </div>
        </div>
    );
};

const AddTool = ({ addSection, openImageModal }) => {
    return (
        <div className="
  bg-white p-2 rounded-lg inline-flex gap-4 shadow-md fixed 
  bottom-4 left-1/2 -translate-x-1/2
  lg:bottom-6 lg:left-1/2
  max-w-full sm:max-w-max overflow-x-auto
">

            <button
                className="flex items-center gap-1 p-2 hover:bg-indigo-100 rounded transition"
                title="Add Description"
                onClick={() => addSection("description")}
            >
                <MessageSquareText />
            </button>
            <button
                className="flex items-center gap-1 p-2 hover:bg-indigo-100 rounded transition cursor-pointer"
                title="Add Image"
                onClick={() => addSection("image")}
            >
                <Image />
            </button>
            <button
                className="flex items-center gap-1 p-2 hover:bg-indigo-100 rounded transition cursor-pointer"
                title="Add Button"
                onClick={() => addSection("button", { text: "", action: "" })}
            >
                <LucideMousePointerClick />
            </button>
        </div>
    );
};

const AuthorSelect = ({ authors = [], onSelect, fetchAuthors, value }) => {
    const [search, setSearch] = useState("");
    const [filteredAuthors, setFilteredAuthors] = useState(authors);
    const [selectedAuthor, setSelectedAuthor] = useState(value);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (value) setSelectedAuthor(value);
    }, [value]);

    // ✅ Fetch authors if not loaded
    useEffect(() => {
        if (!authors.length && fetchAuthors) fetchAuthors();
    }, [authors, fetchAuthors]);

    // ✅ Filter authors on search
    useEffect(() => {
        if (authors.length > 0) {
            setFilteredAuthors(
                authors.filter((a) =>
                    a.title.toLowerCase().includes(search.toLowerCase())
                )
            );
        }
    }, [search, authors]);

    // ✅ Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (author) => {
        setSelectedAuthor(author);
        if (onSelect) onSelect(author);
        setIsOpen(false); // close dropdown
        setSearch(""); // clear search
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <label className="text-[15px] font-semibold text-gray-800 mb-1 block">
                Author
            </label>

            {/* Selected Author / Search Box */}
            <div
                onClick={() => setIsOpen((prev) => !prev)}
                className="border border-gray-300 rounded-lg px-3 py-2 flex justify-between items-center text-sm cursor-pointer bg-white focus-within:ring-2 focus-within:ring-blue-400"
            >
                {console.log(selectedAuthor)}
                {selectedAuthor ? (
                    <span>{selectedAuthor?.title || selectedAuthor}</span>
                ) : (
                    <input
                        type="text"
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setIsOpen(true);
                        }}
                        placeholder="Search author..."
                        className="outline-none w-full bg-transparent"
                    />
                )}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""
                        }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                    />
                </svg>
            </div>

            {/* Dropdown List */}
            {isOpen && (
                <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-40 overflow-y-auto">
                    {filteredAuthors.length > 0 ? (
                        filteredAuthors.map((author) => (
                            <div
                                key={author.id}
                                onClick={() => handleSelect(author)}
                                className="px-3 py-2 text-sm hover:bg-blue-100 cursor-pointer"
                            >
                                {author.title}
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-400 text-sm px-3 py-2">No authors found</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default EditBlog;